
import { defineComponent, onMounted, ref } from 'vue';
import AppContent from '../bases/AppContent.vue';
import ModalMsg from '../bases/ModalMsg.vue';
import '../assets/main.css';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { MinLogger, LOG_LEVEL } from 'min-logger';
declare var google: any;
declare var gapi: any;
declare var window: any;
declare var confSlides: any;

export default defineComponent({
  components: { ModalMsg },
  setup() {
    const router = useRouter();
    const store = useStore();
    const status = ref<'nothing' | 'initializing' | 'running' | 'success' | 'failure'>('nothing');

    const bToken = ref<true | false>(false);
    const bAgree = ref(false);
    const bLogin = ref(false);
    const nPostit = ref(0);
    const nPostit_Total = ref(0);
    const nImage = ref(0);
    const nImage_Total = ref(0);
    const nLabel = ref(0);
    const nLabel_Total = ref(0);
    const nShape = ref(0);
    const nShape_Total = ref(0);
    //const nPen_N = ref(0);
    const nShape_N = ref(0);
    const bChkPolicy = ref(false);

    const minLogger = new MinLogger({
      endpointUrl: 'https://logging-3k3hdubxja-an.a.run.app', //ポストするエンドポイントのURLを指定します。規定値は空
      logKey: 'log', // StorageAPIに格納する際のkeyを指定します。規定値は'log'
      outputLocalStorageLevel: LOG_LEVEL.WARN, // localStorageに格納するログレベルを指定します。LOG_LEVEL.DEBUG ~ LOG_LEVEL.ERRORが指定可能規定値はLOG_LEVEL.WARN
      outputEndpointLevel: LOG_LEVEL.INFO, // エンドポイントに出力するログレベルを指定します。LOG_LEVEL.DEBUG ~ LOG_LEVEL.ERRORが指定可能規定値はLOG_LEVEL.ERROR
      maxLogLocalStorage: 300, // localStorageに格納する最大数を指定します。整数値を指定可能規定値は300
    });

    const shareData = {
      title: 'SuiteコンバーターJamboard版（無償提供）',
      text: 'Google Jamboard のファイルを Suiteシリーズのふせん機能に対応したスライドファイルに変換します',
      url: 'https://suite-jam-converter-web-release.web.app/',
    };

    onMounted(() => {
      bToken.value = false;
      let url = new URL(window.location.href);
      let params = url.searchParams;
      if (store.state.token.token !== null && Date.now() < store.state.token?.untill) {
        bToken.value = true;
        //router.push('/inputUrl');
      }
    });

    const CLIENT_ID = process.env.VUE_APP_OAUTH_CLIENT_ID; //'1051686689410-hi935v8ot3s5b00h5g8qs5hlu6oolrh6.apps.googleusercontent.com';
    const API_KEY = process.env.VUE_APP_OAUTH_API_KEY; //'AIzaSyAtZZC4V2u0AYg7-HIYpr0DgqI09ISYQFY';
    const APP_ID = process.env.VUE_APP_OAUTH_APP_ID; //'1051686689410';
    const DISCOVERY_DOC = 'https://slides.googleapis.com/$discovery/rest?version=v1';
    /*const SCOPES =
      'https://www.googleapis.com/auth/presentations \
      https://www.googleapis.com/auth/userinfo.email';*/
    const SCOPES =
      'https://www.googleapis.com/auth/presentations \
      https://www.googleapis.com/auth/drive.file \
      https://www.googleapis.com/auth/userinfo.email';

    let tokenClient: any;
    let gapiInited = false;
    let gisInited = false;
    let pickerInited = false;
    const SLIDES_BASE_URL = 'https://docs.google.com/presentation/d/';
    let resultURL = '';

    //window.onGapiLoaded = gapiLoaded();
    //window.onGapiLoaded = gisLoaded();

    function logout() {
      const token = gapi.client.getToken();
      if (token !== null) {
        google.accounts.oauth2.revoke(token.access_token);
        gapi.client.setToken('');
      }
      store.commit('setToken', {
        token: null,
        untill: null,
      });
      bToken.value = false;
    }

    function urlOpen(url: string) {
      window.open(url, '_blank');
    }
    function PolicyChk() {
      const element = document.getElementById('agreePrivacy') as HTMLInputElement;
      if (element?.checked === true) {
        bAgree.value = true;
      } else {
        bAgree.value = false;
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      gapiLoaded();
      gisLoaded();
    });

    /**
     * Callback after api.js is loaded.
     */
    function gapiLoaded() {
      // Initialize Picker and Jamboard API.
      gapi.load('client:picker', initializeApis);
    }

    /**
     * Loads Jamboard API and Drive API for Google Picker.
     */
    async function initializeApis() {
      // Load Jamboard API from service-specific Discovery URL.
      try {
        gapi.load('client:auth2', () => {
          gapi.client
            .init({
              apiKey: API_KEY,
              discoveryDocs: [
                DISCOVERY_DOC,
                'https://jamboard.googleapis.com/$discovery/rest?version=v1',
                'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
              ],
            })
            .then(
              () => {
                if (bToken.value) {
                  gapi.client.setToken({ access_token: store.state.token.token });
                }
              },
              (error: any) => {
                //alert(error['details']);
              }
            );
        });
        /*await gapi.client.load(
          'https://jamboard.googleapis.com/$discovery/rest?version=v1&key=' + API_KEY
        );
        console.log('GAPI client loaded for Jamboard API');*/
      } catch (err) {
        console.error('Error loading GAPI client for Jamboard API', err);
      }

      // Load Drive Rest API for picker from public Discovery URL.
      //await gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest');
      pickerInited = true;
      gapiInited = true;
    }

    /**
     * Callback after Google Identity Services are loaded.
     */
    function gisLoaded() {
      tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: SCOPES,
        callback: '', // defined later
      });
      gisInited = true;
    }

    function CheckGapiInited() {
      if (gapiInited === false || gisInited === false) {
        window.setTimeout(CheckGapiInited, 100);
      } else {
        EnableLoginButton();
      }
    }
    CheckGapiInited();

    function EnableLoginButton() {
      bLogin.value = true;
    }

    let lastResult;

    /**
     * Checks whether the element is an embedded image is an image.
     */
    function hasImage(jamElement: any) {
      return Object.prototype.hasOwnProperty.call(jamElement, 'imageValue');
      //return jamElement.hasOwnProperty('imageValue');
    }
    /**
     * Helper to extract image entity id from the element.
     */
    function getImageEntityId(jamElement: any) {
      return jamElement.imageValue.image.entityId.value;
    }

    /**
     *
     */
    // Make sure the client is loaded and sign-in is complete before calling this method.
    async function fetchJamboard(documentId: any) {
      status.value = 'initializing';
      const elem = document.getElementById('app');
      if (elem) {
        elem.style.overflowY = 'hidden';
      }
      try {
        const response = await gapi.client.jamboard.jams.get({
          name: 'jams/' + documentId,
        });
        // response.result is the parsed body.
        lastResult = response.result;
        //console.log(`JSON:${JSON.stringify(response.result)}`);
        //jsonTextArea.value = JSON.stringify(response.result);

        console.log(response.result);
        processResult(response.result);

        status.value = 'running';
        let jamboardData = await createJamStoreData(response.result);
        if (nPostit.value == 0 && nImage.value == 0 && nLabel.value == 0 && nShape.value == 0) {
          alert('変換できるふせん/図形/画像がありません。');
          resetJamboardCount();
          status.value = 'nothing';
          if (elem) {
            elem.style.overflowY = 'auto';
          }
          return;
        }
        await createSlide(jamboardData);
        resetJamboardCount();
      } catch (err) {
        console.error('Execute error', err);
      }
    }

    // Jamboardオブジェクト数の初期化
    function resetJamboardCount() {
      nPostit.value = 0;
      nPostit_Total.value = 0;
      nImage.value = 0;
      nImage_Total.value = 0;
      nLabel.value = 0;
      nLabel_Total.value = 0;
      nShape.value = 0;
      nShape_Total.value = 0;
      //nPen_N.value = 0;
      nShape_N.value = 0;
    }

    let imageUrls: any;
    /**
     * Process jam result by extracting image elements from
     * the first frame and displaying them on the page.
     */
    function processResult(jamResult: any) {
      // Get images from the first frame.
      const images = jamResult.frames[0].elements.filter(
        (e: any) => hasImage(e) && getImageEntityId(e) in jamResult.imageEntityUris
      );
      // Resolve images via URLs map.
      imageUrls = images.map((e: any) =>
        urlConvert(jamResult.imageEntityUris[getImageEntityId(e)])
      );
      //addImages(imageUrls);
      //createImage();
    }

    async function createJamStoreData(jamResult: any) {
      let jamboardDatas: any = [];

      //jamResult.frames.forEach((page: any) => {
      for (const page of jamResult.frames) {
        let frameData: any = [];
        //page.elements.forEach((element: any) => {
        for (const element of page.elements) {
          let elementData: any = {};
          // ふせんの場合
          if (Object.prototype.hasOwnProperty.call(element, 'postitValue')) {
            elementData = {};
            elementData.type = 'postit';
            elementData.text = element.postitValue.text;
            elementData.r = element.backgroundColor.red ? element.backgroundColor.red * 255 : 0;
            elementData.g = element.backgroundColor.green ? element.backgroundColor.green * 255 : 0;
            elementData.b = element.backgroundColor.blue ? element.backgroundColor.blue * 255 : 0;
            elementData.width = element.boundingBox.width;
            elementData.height = element.boundingBox.height;
            elementData.scale = element.scale;
            elementData.topLeftX = element.boundingBox.topLeft.x;
            elementData.topLeftY = element.boundingBox.topLeft.y;

            elementData.fontSize = element.postitValue.textProperties.fontSize;
            elementData.alignment = element.postitValue.textProperties.horizontalAlignment;

            frameData.push(elementData);
            nPostit.value += 1;
            nPostit_Total.value += 1;
          }
          // 図形の場合
          if (Object.prototype.hasOwnProperty.call(element, 'shapeValue')) {
            elementData = {};
            elementData.type = 'shape';
            switch (element.shapeValue.contours[0].points.length) {
              case 4:
                // 四角
                elementData.shapeType = 'RECTANGLE';
                break;
              case 49:
                // 角丸
                elementData.shapeType = 'ROUND_RECTANGLE';
                break;
              default:
                // 考慮されてないやつ
                nShape_N.value += 1;
                continue;
            }
            elementData.r = element.shapeValue.fillColor.red ? element.shapeValue.fillColor.red : 0;
            elementData.g = element.shapeValue.fillColor.green
              ? element.shapeValue.fillColor.green
              : 0;
            elementData.b = element.shapeValue.fillColor.blue
              ? element.shapeValue.fillColor.blue
              : 0;
            elementData.alpha =
              element.shapeValue.fillColor.alpha != null ? element.shapeValue.fillColor.alpha : 1;
            elementData.br = element.shapeValue.strokeColor.red
              ? element.shapeValue.strokeColor.red
              : 0;
            elementData.bg = element.shapeValue.strokeColor.green
              ? element.shapeValue.strokeColor.green
              : 0;
            elementData.bb = element.shapeValue.strokeColor.blue
              ? element.shapeValue.strokeColor.blue
              : 0;
            elementData.width = element.boundingBox.width;
            elementData.height = element.boundingBox.height;
            elementData.scale = element.scale;
            elementData.topLeftX = element.boundingBox.topLeft.x;
            elementData.topLeftY = element.boundingBox.topLeft.y;

            frameData.push(elementData);
            nShape.value += 1;
            nShape_Total.value += 1;
          }
          // ラベルの場合
          if (Object.prototype.hasOwnProperty.call(element, 'labelValue')) {
            elementData = {};
            elementData.type = 'shape';
            elementData.shapeType = 'TEXT_BOX';
            elementData.text = element.labelValue.text;
            elementData.r = element.labelValue.foregroundColor.red
              ? element.labelValue.foregroundColor.red
              : 0;
            elementData.g = element.labelValue.foregroundColor.green
              ? element.labelValue.foregroundColor.green
              : 0;
            elementData.b = element.labelValue.foregroundColor.blue
              ? element.labelValue.foregroundColor.blue
              : 0;
            elementData.width = element.boundingBox.width;
            elementData.height = element.boundingBox.height;
            elementData.scale = element.scale;
            elementData.topLeftX = element.boundingBox.topLeft.x;
            elementData.topLeftY = element.boundingBox.topLeft.y;

            elementData.fontSize = element.labelValue.textProperties.fontSize;
            elementData.holizontalAlignment = element.labelValue.textProperties.horizontalAlignment;

            frameData.push(elementData);
            nLabel.value += 1;
            nLabel_Total.value += 1;
          }
          // 画像の場合
          if (Object.prototype.hasOwnProperty.call(element, 'imageValue')) {
            elementData = {};
            elementData.type = 'image';
            elementData.width = element.boundingBox.width;
            elementData.height = element.boundingBox.height;
            elementData.scale = element.scale;
            elementData.topLeftX = element.boundingBox.topLeft.x;
            elementData.topLeftY = element.boundingBox.topLeft.y;
            elementData.imageUrl = jamResult.imageEntityUris[getImageEntityId(element)];

            frameData.push(elementData);
            nImage_Total.value += 1;
          }
        }

        // 背景画像の場合(1ページ1回)
        if (Object.prototype.hasOwnProperty.call(page, 'background')) {
          if (Object.prototype.hasOwnProperty.call(page.background, 'staticImage')) {
            // 背景が画像ではないとき(パターンなど)
          } else {
            // 背景画像のとき
            let elementData: any = {};
            elementData.type = 'bgImage';
            elementData.imageUrl = await urlConvert(
              jamResult.imageEntityUris[page.background.backgroundImage.image.entityId.value]
            );
            frameData.push(elementData);
          }
        }
        console.log(frameData);
        jamboardDatas.push(frameData);
      }
      // 画像URLのリダレクト処理は時間がかかるのでここでやる
      for (const frameDatas of jamboardDatas) {
        for (const elementData of frameDatas) {
          if (elementData.type == 'image') {
            elementData.imageUrl = await urlConvert(elementData.imageUrl);
            nImage.value += 1;
          }
        }
      }
      console.log(jamboardDatas);
      if (jamboardDatas) jamboardDatas[0].title = jamResult.title;
      return jamboardDatas;
    }

    async function urlConvert(targetURL: string) {
      try {
        // FirebaseのAPIエンドポイント
        const url = 'https://' + process.env.VUE_APP_API_PROJECT_ID + '.web.app/s/';
        const S = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        const N = 16;
        const id = Array.from(Array(N))
          .map(() => S[Math.floor(Math.random() * S.length)])
          .join('');
        // リクエストするパラメタ
        const params = {
          id: id,
          url: targetURL, //targetURL,
        };

        // POSTでリクエスト
        await fetch(url + 'links', {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          headers: {
            Authorization: 'Bearer ' + process.env.VUE_APP_API_TOKEN,
            'content-type': 'application/json',
          },
          body: JSON.stringify(params), // 本体のデータ型は "Content-Type" ヘッダーと一致させる必要があります
          //mode: 'no-cors',
        });
        // shortLinkが短縮URL
        return url + id;
      } catch (error) {
        // エラーが発生したら、短縮前のURLを返す
        return targetURL;
      }
    }

    async function createSlide(jamboardData: any) {
      try {
        const response = await gapi.client.slides.presentations.create({
          title: jamboardData[0].title,
          pageSize: {
            width: { magnitude: 1200, unit: 'PT' },
            height: { magnitude: 800, unit: 'PT' },
          },
        });
        console.log(response);
        // 新しいプレゼンテーションのID
        var presentationId = response.result.presentationId;
        resultURL = SLIDES_BASE_URL + presentationId;
        // 最初のスライドのIDを取得
        var objectId = response.result.slides[0].objectId;
        // スライドを削除/追加するリクエスト
        var requests: any = [];
        requests.push({
          deleteObject: {
            objectId: objectId,
          },
        });

        const ptPerPx = 5.4; // 補正パラメータ
        let pageNum = 1;
        jamboardData.forEach(function (jamboardData: any) {
          requests.push({
            createSlide: {
              objectId: 'slide_' + pageNum,
            },
          });
          for (let i = 0; i < jamboardData.length; i++) {
            let notesData = jamboardData[i];

            // 付箋のとき
            if (notesData.type == 'postit') {
              let colorCode = rgb2Hex(
                Math.trunc(notesData.r),
                Math.trunc(notesData.g),
                Math.trunc(notesData.b)
              );
              let borderColorCode, noteTypesSeq;
              console.log(colorCode);
              switch (colorCode) {
                case '#ffeb3b':
                  //console.log('きいろ');
                  colorCode = confSlides.stickyNote2.noteTypes[4].bgColor;
                  borderColorCode = confSlides.stickyNote2.noteTypes[4].borderColor;
                  noteTypesSeq = 5;
                  break;
                case '#aeea00':
                  //console.log('みどり');
                  colorCode = confSlides.stickyNote2.noteTypes[3].bgColor;
                  borderColorCode = confSlides.stickyNote2.noteTypes[3].borderColor;
                  noteTypesSeq = 4;
                  break;
                case '#80deea':
                  //console.log('あお');
                  colorCode = confSlides.stickyNote2.noteTypes[2].bgColor;
                  borderColorCode = confSlides.stickyNote2.noteTypes[2].borderColor;
                  noteTypesSeq = 3;
                  break;
                case '#ff80ab':
                  //console.log('ピンク');
                  colorCode = confSlides.stickyNote2.noteTypes[8].bgColor;
                  borderColorCode = confSlides.stickyNote2.noteTypes[8].borderColor;
                  noteTypesSeq = 9;
                  break;
                case '#ff9e00':
                  //console.log('オレンジ');
                  colorCode = confSlides.stickyNote2.noteTypes[7].bgColor;
                  borderColorCode = confSlides.stickyNote2.noteTypes[7].borderColor;
                  noteTypesSeq = 8;
                  break;
                case '#000000':
                  //console.log('しろ->薄い灰色');
                  colorCode = confSlides.stickyNote2.noteTypes[5].bgColor;
                  borderColorCode = confSlides.stickyNote2.noteTypes[5].borderColor;
                  noteTypesSeq = 6;
                  break;
                default:
                  colorCode = '#FFFFFF';
                  borderColorCode = '#FFFFFF';
                  break;
              }
              var rgbColor = hex2Rgb(colorCode);
              var BorderRGBColor = hex2Rgb(borderColorCode);
              // 図形を追加するリクエスト
              requests.push({
                createShape: {
                  objectId: 'shape_' + pageNum + '_' + i,
                  shapeType: 'RECTANGLE',
                  elementProperties: {
                    pageObjectId: 'slide_' + pageNum,
                    size: {
                      height: { magnitude: notesData.scale * 100, unit: 'PT' },
                      width: { magnitude: notesData.scale * 100, unit: 'PT' },
                    },
                    transform: {
                      scaleX: 1,
                      scaleY: 1,
                      translateX:
                        (Number(notesData.topLeftX) + 240 - notesData.scale * 240) / ptPerPx,
                      translateY:
                        (Number(notesData.topLeftY) + 240 - notesData.scale * 240) / ptPerPx,
                      unit: 'PT',
                    },
                  },
                },
              });
              // 図形の色を変更するリクエスト
              requests.push({
                updateShapeProperties: {
                  objectId: 'shape_' + pageNum + '_' + i,
                  fields: 'shapeBackgroundFill.solidFill.color, outline',
                  shapeProperties: {
                    shapeBackgroundFill: {
                      solidFill: {
                        color: {
                          rgbColor: {
                            red: rgbColor.r,
                            green: rgbColor.g,
                            blue: rgbColor.b,
                          },
                        },
                      },
                    },
                    outline: {
                      outlineFill: {
                        solidFill: {
                          color: {
                            rgbColor: {
                              red: BorderRGBColor.r,
                              green: BorderRGBColor.g,
                              blue: BorderRGBColor.b,
                            },
                          },
                        },
                      },
                      weight: {
                        magnitude: 2,
                        unit: 'PT',
                      },
                      dashStyle: 'SOLID',
                      propertyState: 'RENDERED',
                    },
                  },
                },
              });
              // 図形に文字を挿入するリクエスト
              requests.push({
                insertText: {
                  objectId: 'shape_' + pageNum + '_' + i,
                  insertionIndex: 0, // テキストを挿入する位置
                  text: notesData.text, // 挿入するテキスト
                },
              });
              if (notesData.text != null) {
                // 文字のスタイルを設定するリクエスト
                requests.push({
                  updateTextStyle: {
                    objectId: 'shape_' + pageNum + '_' + i,
                    textRange: {
                      type: 'ALL',
                    },
                    style: {
                      fontFamily: 'BIZ UDGothic',
                      fontSize: {
                        magnitude: shapeFontSizeFit(notesData) / ptPerPx,
                        unit: 'PT',
                      },
                    },
                    fields: 'fontSize, fontFamily',
                  },
                });
              }
              let description = {
                noteTypesSeq: noteTypesSeq,
                shapeType: 'RECTANGLE',
                googleId: '',
                templateNoteFlg: false,
              };
              // 図形に代替テキストとタイトルを付与するリクエスト
              requests.push({
                updatePageElementAltText: {
                  objectId: 'shape_' + pageNum + '_' + i,
                  title: 'ZETTA_STICKYNOTE',
                  description: JSON.stringify(description),
                },
              });
            } else if (notesData.type == 'shape') {
              // テキストボックス以外
              if (notesData.shapeType != 'TEXT_BOX') {
                // 図形を追加するリクエスト
                requests.push({
                  createShape: {
                    objectId: 'shape_' + pageNum + '_' + i,
                    shapeType: notesData.shapeType,
                    elementProperties: {
                      pageObjectId: 'slide_' + pageNum,
                      size: {
                        height: {
                          magnitude: (notesData.height / ptPerPx) * notesData.scale,
                          unit: 'PT',
                        },
                        width: {
                          magnitude: (notesData.width / ptPerPx) * notesData.scale,
                          unit: 'PT',
                        },
                      },
                      transform: {
                        scaleX: 1,
                        scaleY: 1,
                        translateX:
                          (Number(notesData.topLeftX) +
                            notesData.width / 2 -
                            (notesData.scale * notesData.width) / 2) /
                          ptPerPx,
                        translateY:
                          (Number(notesData.topLeftY) +
                            notesData.height / 2 -
                            (notesData.scale * notesData.height) / 2) /
                          ptPerPx,
                        unit: 'PT',
                      },
                    },
                  },
                });
                console.log(notesData);
                // 図形の色を変更するリクエスト
                requests.push({
                  updateShapeProperties: {
                    objectId: 'shape_' + pageNum + '_' + i,
                    fields:
                      'shapeBackgroundFill.solidFill.color, shapeBackgroundFill.solidFill.alpha, outline',
                    shapeProperties: {
                      shapeBackgroundFill: {
                        solidFill: {
                          color: {
                            rgbColor: {
                              red: notesData.r,
                              green: notesData.g,
                              blue: notesData.b,
                            },
                          },
                          alpha: notesData.alpha,
                        },
                      },
                      outline: {
                        outlineFill: {
                          solidFill: {
                            color: {
                              rgbColor: {
                                red: notesData.br,
                                green: notesData.bg,
                                blue: notesData.bb,
                              },
                            },
                          },
                        },
                        weight: {
                          magnitude: 2,
                          unit: 'PT',
                        },
                        dashStyle: 'SOLID',
                        propertyState: 'RENDERED',
                      },
                    },
                  },
                });
                // テキストボックスの時
              } else {
                console.log(notesData);
                // 図形を追加するリクエスト
                requests.push({
                  createShape: {
                    objectId: 'shape_' + pageNum + '_' + i,
                    shapeType: notesData.shapeType,
                    elementProperties: {
                      pageObjectId: 'slide_' + pageNum,
                      size: {
                        height: {
                          magnitude: (notesData.height / ptPerPx) * notesData.scale,
                          unit: 'PT',
                        },
                        width: {
                          magnitude: (notesData.width / ptPerPx) * notesData.scale,
                          unit: 'PT',
                        },
                      },
                      transform: {
                        scaleX: 1,
                        scaleY: 1,
                        translateX:
                          (Number(notesData.topLeftX) +
                            notesData.width / 2 -
                            (notesData.scale * notesData.width) / 2) /
                          ptPerPx,
                        translateY:
                          (Number(notesData.topLeftY) +
                            notesData.height / 2 -
                            (notesData.scale * notesData.height) / 2) /
                          ptPerPx,
                        unit: 'PT',
                      },
                    },
                  },
                });
                // 図形に文字を挿入するリクエスト
                requests.push({
                  insertText: {
                    objectId: 'shape_' + pageNum + '_' + i,
                    insertionIndex: 0, // テキストを挿入する位置
                    text: notesData.text, // 挿入するテキスト
                  },
                });
                // 文字のスタイルを設定するリクエスト
                if (notesData.text != null) {
                  requests.push({
                    updateTextStyle: {
                      objectId: 'shape_' + pageNum + '_' + i,
                      textRange: {
                        type: 'ALL',
                      },
                      style: {
                        fontFamily: 'BIZ UDGothic',
                        fontSize: {
                          magnitude: shapeFontSizeFit(notesData) / ptPerPx,
                          unit: 'PT',
                        },
                        foregroundColor: {
                          opaqueColor: {
                            rgbColor: {
                              blue: notesData.b,
                              green: notesData.g,
                              red: notesData.r,
                            },
                          },
                        },
                      },
                      fields: 'fontSize, foregroundColor, fontFamily',
                    },
                  });
                  // 文字の配置リクエスト
                  requests.push({
                    updateParagraphStyle: {
                      objectId: 'shape_' + pageNum + '_' + i,
                      textRange: {
                        type: 'ALL',
                      },
                      style: {
                        alignment: notesData.holizontalAlignment,
                      },
                      fields: 'alignment',
                    },
                  });
                }
              }
              // 画像の時
            } else if (notesData.type == 'image') {
              console.log(notesData.imageUrl);
              // 画像を追加するリクエスト
              requests.push({
                createImage: {
                  objectId: 'image_' + pageNum + '_' + i,
                  url: notesData.imageUrl,
                  elementProperties: {
                    pageObjectId: 'slide_' + pageNum,
                    size: {
                      height: {
                        magnitude: (notesData.height / ptPerPx) * notesData.scale,
                        unit: 'PT',
                      },
                      width: {
                        magnitude: (notesData.width / ptPerPx) * notesData.scale,
                        unit: 'PT',
                      },
                    },
                    transform: {
                      scaleX: 1,
                      scaleY: 1,
                      translateX:
                        (Number(notesData.topLeftX) +
                          notesData.width / 2 -
                          (notesData.scale * notesData.width) / 2) /
                        ptPerPx,
                      translateY:
                        (Number(notesData.topLeftY) +
                          notesData.height / 2 -
                          (notesData.scale * notesData.height) / 2) /
                        ptPerPx,
                      unit: 'PT',
                    },
                  },
                },
              });
              // 背景画像用
            } else if (notesData.type == 'bgImage') {
              requests.push({
                updatePageProperties: {
                  objectId: 'slide_' + pageNum,
                  pageProperties: {
                    pageBackgroundFill: {
                      stretchedPictureFill: {
                        contentUrl: notesData.imageUrl,
                      },
                    },
                  },
                  fields: 'pageBackgroundFill',
                },
              });
            }
            console.log(notesData);
          }
          pageNum++;
        });
      } catch (err: any) {
        console.log(err);
      }

      // Execute the request.
      try {
        gapi.client.slides.presentations
          .batchUpdate({
            presentationId: presentationId,
            requests: requests,
          })
          .then((response: any) => {
            //const createImageResponse = response.result.replies;
            //console.log(`Created image with ID: ${createImageResponse[0].createImage.objectId}`);
            //if (callback) callback(createImageResponse);
          });
      } catch (err) {
        //document.getElementById('content').innerText = err.message;
        minLogger.log('SuiteConverter', store.state.userDomain, err);
        return;
      } finally {
        status.value = 'success';
        const elem = document.getElementById('app');
        if (elem) {
          elem.style.overflowY = 'auto';
        }
      }
    }
    /**
     * 現在の図形サイズに文字が収まる様にフォントサイズを変更
     * @param shape 処理対象の図形
     * @returns 変更したフォントサイズ（8～64)
     */
    const CM2IN = 72; //DPI
    function shapeFontSizeFit(notesData: any): number {
      const ptPerPx = 5.4; // 補正パラメータ
      const shapeMargin = 0.1 * CM2IN;

      //フォントサイズを取得
      const elementText = notesData.text;
      if (elementText == null) {
        return 12;
      }
      const fontSize = notesData.fontSize;
      //図形の形を取得する
      //const shapeType = notesData.shapeType;
      //テキストのalignment取得
      //const contentAlignment = notesData.alignment;
      //図形の大きさ取得
      let nowHeight = notesData.height * notesData.scale;
      const nowWidth = notesData.width * notesData.scale;

      //形がノートで中央寄せの場合高さを所定の値だけ引く(現状四角だけなので不要)
      /*if (
        shapeType === SlidesApp.ShapeType.FOLDED_CORNER &&
        contentAlignment === SlidesApp.ContentAlignment.MIDDLE
      ) {
        nowHeight -= 1.7 * 0.3937
      }*/

      //現在の１行あたりの文字数
      const nowLineCharLength = Math.floor((nowWidth - 0.1 * CM2IN * 2) / fontSize);
      //段落配列生成
      const paragraphs = elementText.split('\n');

      // 最適なフォントサイスを見つける
      let newFontSize = 0;

      const ROWLANMAX = 8;
      const FONTSIZEMAX = 64 * ptPerPx;

      for (let rowLen = ROWLANMAX; rowLen >= 2; rowLen--) {
        const wrappingNum = wrappingNumGet(paragraphs, rowLen);
        for (let chkFontSize = FONTSIZEMAX; chkFontSize >= 1; chkFontSize--) {
          if (
            (wrappingNum * 1.05 + 0.5) * chkFontSize <= nowHeight &&
            chkFontSize * rowLen <= nowWidth - 0.1 * CM2IN * 2
          ) {
            newFontSize = chkFontSize;
            break;
          }
        }
        //図形の高さがあまりまくっていたら１行当たりの文字数を少なくしてみる
        if ((wrappingNum * 1.05 + 0.5) * (newFontSize + 1) > nowHeight) {
          break;
        }
      }
      console.log(notesData);
      console.log(newFontSize);
      return newFontSize;
    }

    /**
     * 文字列の行数を取得-折り返しを配慮
     * プロポーショナルフォントは半角がうまく計算できないため、結果がおかしくなる
     * 禁則は配慮しない
     * @param paragraphs 段落毎の文字列
     * @param nowLineCharLength 1行毎の最大文字数
     * @returns 行数
     */
    function wrappingNumGet(paragraphs: string[], nowLineCharLength: number): number {
      let orikaeshiCnt = 0;
      paragraphs.forEach((paragraph) => {
        // 半角文字の数を取得
        const regex = /[ -~]/;
        const count = paragraph.split('').filter(function (char) {
          return regex.test(char);
        }).length;
        // 文字数を算出。半角は0.5とする。少数以下は繰り上げる。
        const lineLength = paragraph.length - count + Math.ceil(count / 2);
        // console.log(`1行の全角での文字数${lineLength}`)
        orikaeshiCnt += Math.ceil(lineLength / nowLineCharLength);
      });
      // console.log(`行数:${orikaeshiCnt}`)
      return orikaeshiCnt;
    }

    function rgb2Hex(r: number, g: number, b: number) {
      // 各色を16進数に変換し、必要に応じてゼロ埋めを行う
      const toHex = (color: number) => color.toString(16).padStart(2, '0');
      // RGB値をHEX形式に変換
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }

    function hex2Rgb(hex: any) {
      // HEXコードからRGB値を取得
      var r = parseInt(hex.slice(1, 3), 16) / 255;
      var g = parseInt(hex.slice(3, 5), 16) / 255;
      var b = parseInt(hex.slice(5, 7), 16) / 255;
      return { r, g, b };
    }

    /**
     *  Create and render a Picker object for searching Jamboards.
     */
    function createPicker() {
      if (Date.now() > store.state.token?.untill) {
        alert('ログインの期限が切れています、再度ログインを行ってください。');
        window.location.reload();
        return;
      }
      const view = new google.picker.View(google.picker.ViewId.DOCS);
      view.setMimeTypes('application/vnd.google-apps.jam');
      const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .setDeveloperKey(API_KEY)
        .setAppId(APP_ID)
        .setLocale('ja')
        .setOAuthToken(store.state.token.token)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setCallback(pickerCallback)
        .build();
      picker.setVisible(true);
    }

    /**
     * Fetches jamboard selected by the user in JSON format.
     * @param {Object} data - Containers the user selection from the picker
     */
    async function pickerCallback(data: any) {
      if (data.action === google.picker.Action.PICKED) {
        const document = data[google.picker.Response.DOCUMENTS][0];
        const documentId = document[google.picker.Document.ID];
        await fetchJamboard(documentId);
      }
    }

    const login = () => {
      tokenClient.callback = async (response: any) => {
        if (response.error !== undefined) {
          throw response;
        }
        const dt = Date.now();
        store.commit('setToken', {
          token: response.access_token,
          untill: dt + response.expires_in * 1000,
        });

        gapi.client.load('oauth2', 'v2', function () {
          gapi.client.oauth2.userinfo.get().execute(function (resp: any) {
            // Shows user email
            console.log(resp);
            store.commit('setUserDomain', resp.email);
            store.commit('setUserPicture', resp.picture);
            minLogger.info('SuiteConverter', resp.email, 'login');

            //var user = gapi.auth2.getAuthInstance().currentUser.get();
            //var grantedScopes = user.getGrantedScopes();
            //console.log('Granted Scopes:', grantedScopes);
            gapi.client
              .request({
                path: 'https://www.googleapis.com/oauth2/v1/tokeninfo',
                params: {
                  access_token: gapi.auth.getToken().access_token,
                },
              })
              .then(
                function (response: any) {
                  var scopes = response.result.scope.split(' ');
                  if (scopes.length < 4) {
                    store.commit('initialize');
                    gapi.auth.signOut();
                    alert('認証に失敗しました。同意画面のチェックが入っているか確認してください。');
                  } else {
                    bToken.value = true;
                  }
                  console.log('Granted Scopes:', response.result.scope);
                },
                function (reason: any) {
                  console.log('Error: ' + reason.result.error.message);
                }
              );
          });
        });
      };

      if (gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({ prompt: 'consent' });
        console.log('prompt');
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({ prompt: '' });
        console.log('none');
      }
    };

    const openResult = () => {
      //window.location.href = resultURL;
      window.open(resultURL, '_blank');
    };

    const openShare = () => {
      navigator.share(shareData);
    };
    return {
      login,
      openResult,
      status,
      bToken,
      bLogin,
      createPicker,
      nPostit,
      nPostit_Total,
      nImage,
      nImage_Total,
      nLabel,
      nLabel_Total,
      nShape,
      nShape_Total,
      //nPen_N,
      nShape_N,
      bAgree,
      bChkPolicy,
      urlOpen,
      PolicyChk,
      openShare,
      logout,
    };
  },
});
